import { FileType } from '@empathy/global/data';

export enum ImageSettingTypeEnum {
  ResearchLargeLogo = 1,
  ResearchSmallLogo = 2,
  RaffleImageLogo = 3
}

export interface TenantImageSettings {
  mediaId: string;
  mediaName: string;
  mediaType: FileType;
  type: ImageSettingTypeEnum;
}

export interface TenantSystemSettings {
  termsAndConditions: string;
  privacyPolicy: string;
  raffleTermsAndConditions: string;
  cookiePolicy: string;
  supportText: string;
  mailApiKey: string;
  mailReplyTo: string;
  mailSenderName: string;
  mailUnsubscribeGroupId: number;
  imageSettings: TenantImageSettings[];
}
